import React from 'react';
import { Button, Row, Col, Toast } from '@kaleyra/emmy';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import Styles from './index.module.scss';
import { REDIRECT_URL } from '../../base';
import { IStateType } from '../../store/models/root.interface';
import { checkSubaccount, checkIsNonPrimaryRole, getCookie } from '../../utils';

// import NewKycImg from '../../assets/warningWhite.png';
import FailedKycImg from '../../assets/errorRed.png';
import PendingKycImg from '../../assets/warningOrange.png';
import leftArrowWhite from '../../assets/leftArrowWhite.svg'
import { useHistory } from 'react-router-dom';
import Info from '../../assets/infoIconBlack.svg'
import InfoWhite from '../../assets/infoIconWhite.svg'


export type DispatchPropsType = {
    backToParentAccount: (data: any, callBack: any) => void;
    onLoad: () => void;
    requestLogout: () => void;
};
const KycBanner: React.FC<DispatchPropsType> = ({
    backToParentAccount,
    onLoad,
    requestLogout
}) => {
    const { t } = useTranslation();
    const history = useHistory();

    const profile = useSelector((state: IStateType) => state.profile);
    const { kyc_status } = profile.fullProfile;
    const { account_name }: any = profile.fullProfile;

    const renderNewKyc = () => {
        return (
            <>
                {checkSubaccount() ?
                    (
                        <div className={Styles.kycBannerSubaccount}>
                            <img src={InfoWhite} alt="complete Kyc" style={{ paddingInline: 10 }} />
                            {t("KLR02584")}
                        </div>
                    ) :
                    <div className={Styles.mainBanner}>
                        <div className={Styles.newKyc}>
                            {/* <img src={NewKycImg} alt="complete Kyc"/> */}
                            {checkIsNonPrimaryRole() ? t("KLR02613") : t("kycTrialVersion")}
                            {!checkIsNonPrimaryRole() &&
                                <a href={REDIRECT_URL + `/billing/preferences`}>
                                    <Button type="primary"> {t("kycCompleteUrKyc")} </Button>
                                </a>
                            }
                            {/* <a href={REDIRECT_URL + `/billing/preferences`}>{`${t("mainClickHere")} `}</a>
                    {t("kycToLearnMore")} */}
                        </div>
                    </div>
                }
            </>
        )
    }

    const renderFailedKyc = () => {
        return (
            <>
                {checkSubaccount() ?
                    (
                        <div className={Styles.kycBannerSubaccount}>
                            <img src={InfoWhite} alt="complete Kyc" style={{ paddingInline: 10 }} />
                            {t("KLR02584")}
                        </div>
                    ) :
                    <div className={Styles.mainBanner}>
                        <div className={Styles.failedKyc}>
                            {/* <img src={FailedKycImg} alt="failed Kyc"/> */}
                            {t("kycFailed")}
                            {!checkIsNonPrimaryRole() &&
                                <a href={REDIRECT_URL + `/billing/preferences`}>
                                    <Button type="primary"> {t("kycRetryKyc")} </Button>
                                </a>
                            }
                        </div>
                    </div>
                }
            </>
        )
    }

    const renderPendingKyc = () => {
        return (
            <>
                {checkSubaccount() ?
                    (
                        <div className={Styles.kycBannerSubaccount}>
                            <img src={InfoWhite} alt="complete Kyc" style={{ paddingInline: 10 }} />
                            {t("KLR02584")}
                        </div>
                    ) :
                    <div className={Styles.mainBanner}>
                        <div className={Styles.pendingKyc}>
                            {/* <img src={PendingKycImg} alt="pending Kyc"/> */}
                            {t("kycPending")}
                        </div>
                    </div>
                }
            </>
        )
    }
    const handleBackToMain = () => {
        backToParentAccount({}, (resp: any, success: boolean) => {
            if (success) {
                localStorage.removeItem("for-user-id");
                document.cookie = "is_parent_as_child_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                onLoad()
                history.push('/subaccounts/manage-subaccounts');
                Toast('Request Successful', 'success')
            }
            else {
                localStorage.removeItem("for-user-id");
                document.cookie = "is_parent_as_child_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                requestLogout()
            }

        })
    }

    return (
        <>
            {getCookie('is_parent_as_child_session') ? (
                <>
                    <div>
                        <div className={Styles.backToMainBanner} >
                            <Row >
                                <Col size={3} className={Styles.backToMain}>
                                    <img src={leftArrowWhite} className={Styles.leftArrow}
                                        onClick={() => {
                                            handleBackToMain()
                                        }}
                                    />
                                    <a className={Styles.backToMainText} onClick={() => { handleBackToMain() }}>{t("KLR02532")}</a>
                                </Col>
                                <Col size={6}>
                                    <div style={{ textAlign: 'center' }}>
                                        {t("KLR02533", { "account_name": account_name })}
                                    </div>
                                </Col>
                            </Row>
                        </div>

                    </div>
                    {(kyc_status === "NEW-KYC" || kyc_status === "FAILED" || kyc_status === "PENDING") &&
                        <div className={Styles.kycBannerForParentAsChild}>
                            <img src={Info} style={{ paddingInline: 10 }} />
                            {t("KLR02531")}
                        </div>
                    }
                </>
            )
                : (
                    <>
                        {kyc_status === "NEW-KYC" && renderNewKyc()}
                        {kyc_status === "FAILED" && renderFailedKyc()}
                        {kyc_status === "PENDING" && renderPendingKyc()}
                    </>
                )}
        </>
    )
}

export default KycBanner;